import { Input, Label } from "reactstrap";

const ManageOrderTableHeader = () => {
  return (
    <thead>
      <tr>
        <th>
          <div className="form-check">
            <Input type="checkbox" />
            <Label />
          </div>
        </th>
        <th>Products name</th>
        <th>ID</th>
        <th>Date</th>
        <th>Price</th>
        <th>Status</th>
        <th>Quantity</th>
      </tr>
    </thead>
  );
};

export default ManageOrderTableHeader;
